import { useEffect, useState, Fragment, useRef } from 'react';
import axios from 'axios';
import { Card, Typography } from "@material-tailwind/react";
import ModalCreateClient from './ModalCreateClient';
import ModalModifyClient from './ModalModifyClient';


function AnnuaireClient() {
    const [datas, setDate] = useState([])
    const [listServer, setListServer] = useState([])
    const [sortedBy, setSortedBy] = useState()
    const [counter, setCounter] = useState(0)
    const [search, setSearch] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalModify, setShowModalModify] = useState(false);

    const [serverNames, setServerNames] = useState([]);
    const [selectedServerNames, setSelectedServerNames] = useState({});
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [filterOldDates, setFilterOldDates] = useState(false);

    const filterButtonRef = useRef(null);
    const filterMenuRef = useRef(null);

    const [choosenClient, setChoosenClient] = useState({
        id_cli: '',
        nom: '',
        nb_ecrans: '',
        serveur: '',
        date_pose: '',
        date_limite: '',
        remarque: ''
    });
    const dateToday = new Date();

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_all_clients`)
            .then(res => {
                setDate(res.data.sort((a, b) => (a.date_limite > b.date_limite) ? 1 : -1))
            })
            .catch(err => console.log(err))
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_serveur`)
            .then(res => {
                setListServer(res.data)
            })
            .catch(err => console.log(err))

        // Chargement de la recherche (si vous voulez la sauvegarder aussi)
        const savedSearch = localStorage.getItem('annuaireSearchValue');
        if (savedSearch) {
            setSearch(savedSearch);
        }

        // Chargement des filtres de serveur
        const savedFilters = localStorage.getItem('selectedServerFilters');
        if (savedFilters) {
            try {
                setSelectedServerNames(JSON.parse(savedFilters));
            } catch (e) {
                console.error("Erreur chargement filtres serveur:", e);
                localStorage.removeItem('selectedServerFilters');
            }
        }

        const savedOldDateFilter = localStorage.getItem('selectedOldDateFilter');
        // On vérifie explicitement 'true' car localStorage stocke des chaînes
        if (savedOldDateFilter === 'true') {
            setFilterOldDates(true);
        }
    }, [])

    // Extraction des noms de serveurs uniques
    useEffect(() => {
        if (datas.length > 0) {
            const uniqueServers = [...new Set(datas.map(item => item.nom_serveur).filter(Boolean))];
            setServerNames(uniqueServers.sort());
        }
    }, [datas]);

    // Fermeture du popover au clic extérieur
    useEffect(() => {
        function handleClickOutside(event) {
            if (
                isFilterOpen &&
                filterButtonRef.current && !filterButtonRef.current.contains(event.target) &&
                filterMenuRef.current && !filterMenuRef.current.contains(event.target)
            ) {
                setIsFilterOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isFilterOpen]);

    // Sauvegarde des filtres dans localStorage
    useEffect(() => {
        localStorage.setItem('selectedServerFilters', JSON.stringify(selectedServerNames));
    }, [selectedServerNames]);

    useEffect(() => {
        localStorage.setItem('selectedOldDateFilter', filterOldDates);
    }, [filterOldDates]);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearch(value);
        localStorage.setItem('annuaireSearchValue', value); // Sauvegarde de la recherche
    };

    const handleServerTypeChange = (e) => {
        const { name, checked } = e.target;
        setSelectedServerNames(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleOldDateFilterChange = (e) => {
        setFilterOldDates(e.target.checked);
    };

    const handleResetFilters = () => {
        setSelectedServerNames({});
        setIsFilterOpen(false);
    };

    const TABLE_HEAD = [
        { key: "nom", text: "Nom Client" },
        { key: "nb_ecran", text: "Nombre d'écrans" },
        { key: "date_pose", text: "Date de pose" },
        { key: "date_limite", text: "Date Limite" },
        { key: "nom_serveur", text: "Nom Serveur" },
        { key: "remarque", text: "Remarque" },
        { key: "edit", text: "Edit" },
    ];
    const linkServer = (serverLink) => (e) => {
        e.preventDefault();
        console.log(serverLink);
        window.open(serverLink, '_blank')
    }
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const targetDate = new Date('2050-01-01');

    const filteredDatas = datas.filter(dataItem => {
        // 1. Filtre par nom de serveur
        const checkedServers = Object.keys(selectedServerNames).filter(key => selectedServerNames[key]);
        let serverFilterPassed = true;
        if (checkedServers.length > 0) {
            serverFilterPassed = checkedServers.includes(dataItem.nom_serveur);
        }

        // 2. Filtre par recherche
        const searchTerm = search.toLowerCase();
        const searchFilterPassed = (searchTerm === ''
            ? true
            : dataItem.nom.toLowerCase().includes(searchTerm) ||
            dataItem.nom_serveur.toLowerCase().includes(searchTerm) ||
            (dataItem.remarque && dataItem.remarque.toLowerCase().includes(searchTerm))
        );

        let oldDateFilterPassed = true; // Passe par défaut
        if (filterOldDates) { // Si la case est cochée
            const clientDate = new Date(dataItem.date_limite);
            // La condition doit être remplie pour passer
            oldDateFilterPassed = clientDate < targetDate;
        }

        return serverFilterPassed && searchFilterPassed && oldDateFilterPassed;
    });

    const sorted = filteredDatas.sort((a, b) => {

        const aVal = a[sortedBy];
        const bVal = b[sortedBy];
        if (typeof aVal === "number" && typeof bVal === "number") {
            if (counter % 2 === 0) return aVal - bVal;
            else return bVal - aVal;
        }
        else if (typeof aVal === "string" && typeof bVal === "string") {
            if (counter % 2 === 0) return aVal.localeCompare(bVal);
            else return bVal.localeCompare(aVal);
        }
        return 1;
    });

    const FilterPopover = () => (
        <div
            ref={filterMenuRef}
            className="absolute top-full left-0 mt-2 w-72 p-4 bg-white rounded-xl border border-slate-200 shadow-xl z-10"
        >
            <h4 className="text-sm font-semibold uppercase tracking-wide mb-3 text-slate-500">Filtres</h4>

            <div className="flex items-center mb-3 pb-3 border-b border-slate-200">
                <input
                    type="checkbox"
                    id="filter-old-date"
                    checked={filterOldDates}
                    onChange={handleOldDateFilterChange}
                    className="mr-2 h-4 w-4 rounded accent-indigo-500"
                />
                <label
                    htmlFor="filter-old-date"
                    className="text-sm select-none cursor-pointer text-slate-700"
                >
                    Expire bientôt
                </label>
            </div>

            <h5 className="text-xs font-semibold uppercase tracking-wide mb-2 text-slate-500">Par serveur</h5>
            <div className="grid grid-cols-1 gap-y-2 max-h-40 overflow-y-auto"> {/* Hauteur max réduite */}
                {serverNames.map((name) => (
                    <div key={name} className="flex items-center">
                        <input
                            type="checkbox"
                            id={`filter-srv-${name}`}
                            name={name}
                            checked={selectedServerNames[name] || false}
                            onChange={handleServerTypeChange}
                            className="mr-2 h-4 w-4 rounded accent-indigo-500"
                        />
                        <label
                            htmlFor={`filter-srv-${name}`}
                            className="text-sm select-none cursor-pointer text-slate-700"
                        >
                            {name}
                        </label>
                    </div>
                ))}
            </div>

            <hr className="my-4 border-slate-200" />

            <button
                onClick={handleResetFilters}
                className="w-full rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 transition-colors"
            >
                Réinitialiser les filtres
            </button>
        </div>
    );

    const ListClient = (() => {
        return (
            <Card className="w-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                <div className="overflow-x-auto">
                {/* Pas de min-w-max : le tableau tient dans la page (la remarque wrappe au lieu de
                    forcer un scroll horizontal). */}
                <table className="w-full table-auto text-left">
                    <thead>
                        <tr className='sticky top-0 border-b border-slate-200 bg-slate-50'>
                            {TABLE_HEAD.map((head) => (
                                <th
                                    key={head.key}
                                    className="cursor-pointer whitespace-nowrap px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 hover:text-slate-700"
                                    onClick={() => { setSortedBy(head.key); setCounter(counter + 1) }}
                                >
                                    <Typography
                                        variant="small"
                                        className="font-semibold leading-none uppercase tracking-wide"
                                    >
                                        {head.text}
                                    </Typography>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {sorted.map((data, index) => {
                            const isLast = index === data.length - 1;
                            // Les cellules wrappent (plus de whitespace-nowrap) -> tout est visible sans scroll.
                            const classes = isLast ? "break-words px-3 py-3 text-sm text-slate-700 align-top" : "break-words px-3 py-3 text-sm text-slate-700 align-top border-b border-slate-100";

                            let differenceDate = dateToday.getTime() - new Date(data.date_limite).getTime();
                            let differenceDays = differenceDate / (1000 * 3600 * 24)


                            let classBackground
                            if (differenceDays.toFixed() > -15 && differenceDays.toFixed() < 15) {
                                classBackground = "cursor-pointer border-b border-slate-100 bg-amber-50 text-slate-800 transition-colors hover:bg-amber-100"
                            } else if (differenceDays.toFixed() > 15) {
                                classBackground = "cursor-pointer border-b border-slate-100 bg-red-50 text-slate-800 transition-colors hover:bg-red-100"

                            } else {
                                classBackground = "cursor-pointer border-b border-slate-100 text-slate-700 transition-colors hover:bg-indigo-50/40"
                            }


                            return (
                                <tr key={data.id_cli} className={classBackground} >
                                    <td className={classes} onClick={linkServer(data.url_serveur)} >
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data.nom}
                                        </Typography>
                                    </td>
                                    <td className={classes} onClick={linkServer(data.url_serveur)} >
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data.nb_ecran}
                                        </Typography>
                                    </td>
                                    <td className={classes} onClick={linkServer(data.url_serveur)} >
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {new Date(data.date_pose).toLocaleDateString('fr-FR')}
                                        </Typography>
                                    </td>
                                    <td className={classes} onClick={linkServer(data.url_serveur)} >
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {new Date(data.date_limite).toLocaleDateString('fr-FR')}
                                        </Typography>
                                    </td>
                                    <td className={classes} onClick={linkServer(data.url_serveur)} >
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data.nom_serveur}
                                        </Typography>
                                    </td>
                                    <td className={classes} onClick={linkServer(data.url_serveur)} >
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data.remarque}
                                        </Typography>
                                    </td>
                                    <td className={classes} >
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer" onClick={() => { setShowModalModify(true); setChoosenClient({ ...choosenClient, id_cli: data.id_cli, nom: data.nom, nb_ecrans: data.nb_ecran, serveur: data.id_serveur, date_pose: data.date_pose, date_limite: data.date_limite, remarque: data.remarque }) }}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a4.5 4.5 0 01.9-2.7L5.737 5.1a3.375 3.375 0 012.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 01.9 2.7m0 0a3 3 0 01-3 3m0 3h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008zm-3 6h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008z" />
                                        </svg>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                </div>
            </Card>
        );
    })

    return (
        <Fragment>
            <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
                <div className="mb-4">
                    <h1 className="text-xl font-semibold text-slate-800">Clients</h1>
                    <p className="text-sm text-slate-500">Annuaire des clients et échéances.</p>
                </div>
                <div className='flex items-center gap-2 my-2'>
                    <div className="relative">
                        <button
                            ref={filterButtonRef}
                            onClick={() => setIsFilterOpen(!isFilterOpen)}
                            className="flex h-9 items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 3c-1.1 0-2 .9-2 2v1.17a3 3 0 01-.88 2.12L4.5 13.5V18a1 1 0 001 1h13a1 1 0 001-1v-4.5l-4.62-5.21A3 3 0 0114 6.17V5a2 2 0 00-2-2z" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="M10 18h4" />
                            </svg>
                            Filtres
                        </button>
                        {isFilterOpen && <FilterPopover />}
                    </div>
                    <div className="relative flex h-10 w-full max-w-md items-center rounded-xl border border-slate-200 bg-white shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20">
                        <svg xmlns="http://www.w3.org/2000/svg" className="ml-3 h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>

                        <input
                            className="h-full w-full rounded-xl bg-transparent px-3 text-sm text-slate-800 placeholder-slate-400 outline-none"
                            type="text"
                            id="search"
                            placeholder="Rechercher un client..."
                            value={search}
                            onChange={handleSearchChange} />
                    </div>
                </div>
                <main className="flex flex-row justify-between mt-4">
                    {ListClient()}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-16 right-6 cursor-pointer" onClick={() => scrollToTop()}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-6 right-6 cursor-pointer" onClick={() => setShowModal(true)} >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </main>
            </div>
            <ModalCreateClient isVisible={showModal} onClose={() => setShowModal(false)} listServer={listServer} />
            <ModalModifyClient isVisible={showModalModify} onClose={() => setShowModalModify(false)} choosenClient={choosenClient} listServer={listServer} />

        </Fragment>
    )
}
export default AnnuaireClient;